import { ApiResponse } from 'mds-ui/app/shared/model/apiresponse';

export class Organization{
    id: number;
    name: string;
    serenicId: number;
    nsCustomerId: String;
    nsLocationId: string;
    nsLocationNameId: string;
    hrLocationId: string;
    ori: string;
    oca: string;
    previousOca: string;
    mailCode: string;
    ministryType: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    organizationAddress: OrganizationAddress;
    organizationContacts: Array<OrganizationContact>;
}
export class OrganizationAddress{
    id: number;
    organization: Organization;
    addressLine1: string;
    addressLine2: string;
    city: string;
    county: string;
    state: string;
    zipCode: string;
    emailId: string;
    phone: string;
    phoneExt: string;
    fax: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
    organizationId:number;
   
}
export class OrganizationContact{
    id: number;
    organization: Organization;
    applicationId: number;
    contactType: string;
    firstName: string;
    lastName: string;
    emailId: string;
    contact: string;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}
export class OrganizationSearch{
    id: Array<number>;
    orgName: string;
    firstName: string;
    lastName: string;
    name: string;
    ministryType: string;
    isActive: string;
    appId: number;
    username: string;
    pageNo: number;
    pageSize: number;
    idSort: string;
    locNameSort: string;
}
export class OrganizationResponse{
    apiResponseVO: ApiResponse;
    count: number;
    organizationVOList: Array<Organization>;
    organizationWebInfo: OrganizationWebInfoResponse;
    length: number;
    organizationAddress: any;
    
}
export class OrganizationPriestSearch{
    id: number;
    organizationName: string;
    name: string;
    year: Date;
    isActive: string;
    createdBy: string;
    createdTime: Date;
    lastUpdatedBy: string;
    lastUpdatedTime: Date;
}

export class SearchVO{
    organizationName: string;
    pageNo: number;
    pageSize: number;   
    appId: number;
    isActive: string;
    requestOrigin: string;
    
}
export class OrganizationPriestSearchResponse{
    apiResponseVO: ApiResponse;
    count: number;
    organizationListVOList: Array<OrganizationPriestSearch>;
}

// OMI


export class OrganizationWebInfoResponse {
    id: number;
    createdBy: string;
    lastUpdatedBy: string;
    organizationId: number;
    type: string;
    url: string;
    isActive: string;
    apiResponseVO: APIResponseVO;
    filter: any;
    length: number;
    organizationWebInfo:any;
   
}

export class APIResponseVO {
    apiResponseCodeId: number;
    status: string;
    code: string;
    type: string;
    message: string;
    detailMessage: string;
    moreInfo: string;
    createdBy: string;
    createdTime: string;
    lastUpdatedBy: string;
    lastUpdatedTime: string;
}


export class OrganizationWorshipTimesResponse{
    comment: string;
    createdBy: string;
    createdTime:string;
    endTime: string;
    friday: number;
    id: number;
    isActive: string;
    isLivestream: string;
    livestreamUrl:string;
    location:string;
    language: string;
    otherLanguage: string;
    lastUpdatedBy: string;
    lastUpdatedTime: string;
    monday: number;
    organizationId: number;
    saturday: number;
    serviceType: string;
    startTime: string;
    sunday: number;
    thursday: number;
    tuesday: number;
    wednesday: number;
    url: string;
    apiResponseVO: APIResponseVO;
    filter: any;
    reduce:any;
    parishWorshipInfo: any;
    length: number;
  
}

export class OrganizationOfficeHoursResponse{
    comment: string;
    createdBy: string;
    createdTime:string;
    endTime: string;
    friday: number;
    id: number;
    isActive: string;
    isLivestream: string;
    language: string;
    lastUpdatedBy: string;
    lastUpdatedTime: string;
    monday: number;
    organizationId: number;
    type:string;
    saturday: number;
    serviceType: string;
    startTime: string;
    sunday: number;
    thursday: number;
    tuesday: number;
    wednesday: number;
    url: string;
    apiResponseVO: APIResponseVO;
    filter: any;
    reduce:any;
    organizationOfficeHoursInfo:any;
    length: number;
  
   
}

export class OrganizationDescriptionResponse {
    id: number;
    organizationId: number;
    description: string;
    isActive: string;
    createdBy: string;
    lastUpdatedBy: string;
    apiResponseVO: APIResponseVO;
    filter: any;
    organizationDescriptionInfo: any;
    length: number;
   
}